import type { ReactNode, MouseEvent, CSSProperties } from 'react'
import { useNavigate } from 'react-router-dom'

interface LinkProps {
    href: string
    children: ReactNode
    className?: string
    style?: CSSProperties
    state?: unknown
    testId?: string
}

const Link = ({ href, children, className, style, state, testId }: LinkProps) => {
    const navigate = useNavigate()

    const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return
        e.preventDefault()
        navigate(href, { state })
    }

    return (
        <a href={href} className={className} style={style} onClick={handleClick} draggable={false} data-testid={testId}>
            {children}
        </a>
    )
}

export default Link
